import React, { useEffect, useState } from 'react'
import Button from '../../../../utils/components/Button/Button'
import Input from '../../../../utils/components/Input/Input'
import useModal from '../../../../utils/hooks/useModal'
import { usePlaces } from '../../../../utils/hooks/usePlaces'
import style from "./CreateAdvertising.module.css"
const CreateAdvertising = ({ formik, add, isEdit = false }) => {
  const [srcImg, setSrcImg] = useState(null)

  useEffect(() => {
    if (add?._id) {
      setSrcImg(add.image && add.image.url && add.image.url.origin)
     
    }

    return () => {

    }
  }, [add])


  return (
    <div>
      <div className={style.form_container}>
        <label className={style.form_img}>
          {srcImg && <img className={style.form_img} src={srcImg} alt="" />}
          <input name="picture" type="file"
            onChange={(e) => {

              if (e.target.files[0] && e.target.files[0].type.includes('image')) {
                formik.setFieldValue("image", e.target.files[0])


                setSrcImg(URL.createObjectURL(e.target.files[0]))
              }
            }}
          />
        </label>

      </div>

    
      <div className={style.form_container}>
        <Input
          classNameInput={style.input_form}
          name="url"
          type="text"
          placeholder={'Link'}
          value={formik.values.url}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.url}
        />
        <div className='input-select-style-container'>
          <select
            className={`input-select-style ${style.input_select}`}
            name="advertisingType"
            value={formik.values.advertisingType}
            onChange={formik.handleChange}
          >
            <option value="">Tipo de publicidad</option>
            <option value="image">Imagen</option>
            <option value="banner">Banner</option>
            <option value="promotion">Promoción</option>
            
          </select>
          <div className={`text-error-input`}>{formik.errors.advertisingType}</div>
        </div>
      </div>
      
      
      <div className={style.form_container}>

        <Button
          type='submit'
          onClick={formik.handleSubmit}
          text='Crear'
        />
      </div>







    </div>
  )
}

export default CreateAdvertising